import AccessManagement from "./AccessManagement";

export default AccessManagement;
